import Image from 'next/image';
import { CSSProperties } from 'react';

import younitedIcon from '@assets/logo-younited.svg';

interface YounitedIconProps {
    height?: number;
    style?: CSSProperties;
}

export function YounitedIcon({ height = 16, ...props }: Readonly<YounitedIconProps>) {
    const image = younitedIcon;

    return <Image height={height} blurDataURL={image} src={image} alt='Younited' priority {...props} />;
}
